/**
 * No-op SystemBars for web platform.
 * react-native-edge-to-edge is Android/iOS only.
 */
const SystemBars = () => null;

export { SystemBars };
